import React from 'react';
import { Field, useFormikContext } from 'formik';
import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    Radio,
    RadioGroup as MUIRadioGroup,
    RadioGroupProps,
    Typography,
} from '@mui/material';
import { GenericObject } from '@fnol/library/src/lib';
import { legalPersonType, translations } from '../../lib/consts';

const LegalIndividualSelector = () => {
    const { errors, touched } = useFormikContext<GenericObject>();

    const type = `submitterType`;

    const RadioGroup = (params: RadioGroupProps) => {
        return (
            <MUIRadioGroup {...params} row sx={{ marginTop: '-15px' }}>
                <FormControlLabel
                    value={legalPersonType.individual}
                    control={<Radio />}
                    label={translations.legalPersonType.INDIVIDUAL}
                />
                <FormControlLabel
                    value={legalPersonType.legal}
                    control={<Radio />}
                    label={translations.legalPersonType.LEGAL}
                />
            </MUIRadioGroup>
        );
    };

    return (
        <>
            <Typography style={{ fontWeight: 'bold', fontSize: '18px', paddingTop: '16px' }} variant="caption">
                {translations.CHOOSE_SUBMITTER_TYPE}
            </Typography>
            <FormControl required={true}>
                <Field name={type} as={RadioGroup} size="big" />

                {touched[type] && errors[type] ? (
                    <FormHelperText error={true}>
                        <>{errors[type]}</>
                    </FormHelperText>
                ) : null}
            </FormControl>
        </>
    );
};

export default LegalIndividualSelector;
